const SettingTab = () => {
    return(
        <div></div>
    )
}
export default SettingTab;